import { Button, Typography } from '@/components';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useTranslation } from 'react-i18next';

type ReviewEoiCardProps = {
  readonly onAccept: () => void;
  readonly onDecline: () => void;
};

export function SellerReviewEoiCard({ onAccept, onDecline }: ReviewEoiCardProps) {
  const { t } = useTranslation(['offers']);

  return (
    <Card className="border-primary-200 mb-6 hidden border bg-emerald-50/50 backdrop-blur-sm lg:block">
      <CardHeader className="py-1">
        <CardTitle className="flex items-center">Review Expression of Interest</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <Typography size="body-3">
          Accepting opens kick-off scheduling. Declining shares your structured feedback with the buyer.
        </Typography>
        <Button size="sm" color="primary" className="w-full" onClick={onAccept} icon="check">
          {t('Accept EOI')}
        </Button>
        <Button size="sm" color="ghost" className="w-full" onClick={onDecline} icon="thumb-down">
          {t('Decline EOI')}
        </Button>
      </CardContent>
    </Card>
  );
}
